import { ApolloClient } from "apollo-client"
import { InMemoryCache } from "apollo-cache-inmemory"
import { HttpLink } from "apollo-link-http"
import { ApolloLink, from } from "apollo-link"
import fetch from "unfetch"
import {
  API_URL,
  APP_ID,
  COMPANY_ID,
  HOME_API_URL
} from "./constants"
import { isAuthenticated } from "../utils/utils"
import { getDeviceId, inBrowser, decodeUserToken } from "@omnichannel/ace-b2b-elements"
// import decodeUserToken from "./decodeUserToken"
import { getCompanyId } from '../utils/utils'

let deviceId = undefined
if (inBrowser) {
  getDeviceId().then(result => {
    deviceId = result
  })
}

let userInfo = null
const accessToken = inBrowser ? localStorage.getItem("access-token") : ""
if (accessToken) {
  userInfo = decodeUserToken(accessToken)
}

const appMiddleware = new ApolloLink((operation, forward) => {
  let bearerAccessToken = "x"
  const accessToken = (inBrowser && localStorage.getItem("access-token")) || ""
  if (accessToken.length) {
    bearerAccessToken = `Bearer ${accessToken}`
  }

  const branch = JSON.parse(
    (inBrowser && localStorage.getItem("ace_app_branch")) || "{}"
  )
  let branchId = branch._id

  operation.setContext(({ headers = {} }) => {
    headers = {
      ...headers,
      appid: APP_ID,
      // companyId: COMPANY_ID, //getCompanyId(),
      companyId: getCompanyId(),
      deviceId,
      user: userInfo ? userInfo._id : "",
      Authorization: bearerAccessToken,
      ...(branchId ? { branchId } : {}),
    }
    let token = ""
    if (isAuthenticated()) {
      if (token) {
        headers.token = token
      }
    }
    // console.log("headers::", headers)
    return { headers }
  })
  return forward(operation)
})

const httpLink = new HttpLink({
  uri: HOME_API_URL ? HOME_API_URL : `${API_URL}/homepage/graphql`,
  fetch,
})

const smClient = new ApolloClient({
  cache: inBrowser
    ? new InMemoryCache().restore(window.__APOLLO_STATE__)
    : new InMemoryCache(),
  link: from([appMiddleware, httpLink]),
})

export default smClient
